<template>
    <div class="full-width">
        <img src="@/assets/resource/img/full-width02.png" alt="" class="full-width--bg">
        <h4 class="title03">
            칭찬은 하는 사람과 받는 사람<br class="show-mo"> 모두를 즐겁게 합니다. <br>
            하나의 칭찬이 또 다른 칭찬을<br class="show-mo"> 만들어 갈 수 있도록<br class="show-mo"> 직원들을 칭찬해주세요.
        </h4>
        <div class="botton-wrap">
            <router-link to="/kr/thanks/register" class="main-button c-main">고맙습니다 글쓰기</router-link>
            <router-link to="/kr/mypage/board/myThanks" class="sub-button c-main">작성한 글로 바로가기</router-link>
        </div>
    </div>
    
    <!-- 20251217 이대목동 고객센터 요청 -->
    <div class="info" v-if="showStepBox">
        <ul class="step-box" style="margin-bottom: 80px;">
            <li class="step-box__item">
                <span class="step-box__item--step">STEP 01</span>

                <div class="step-box__item__top">
                    <h4 class="title03">홈페이지 로그인</h4>
                </div>

                <div class="step-box__item__bottom">

                </div>
            </li>
            <li class="step-box__item">
                <span class="step-box__item--step">STEP 02</span>
                <div class="step-box__item__top">
                    <h4 class="title03">내 진료 정보 ▶ &lsquo;고맙습니다&rsquo; 선택</h4>
                </div>
                <div class="step-box__item__bottom">
                    <p>
                        <a href="/kr/mypage/board/myThanks" class="sub-button small c-main">내 진료 정보</a>
                    </p>
                </div>
            </li>
            <li class="step-box__item" >
                <span class="step-box__item--step">STEP 03</span>
                <div class="step-box__item__top">
                    <h4 class="title03">답변 내용 확인</h4>
                </div>
                <div class="step-box__item__bottom">

                </div>
            </li>
        </ul>
        
        <h3 class="bullet01">고객의 소리</h3>
    </div>


    <ul class="box-board thanks">
        <li class="box-board__item" v-for="article in list">
            <router-link :to="`/${$store.getters.getLang}/${board.boardId}/view?boardNo=${board.boardNo}&articleNo=${article.articleNo}`">
                <h3 class="title02">{{article.title}}</h3>
                <div class="box-board__con">
                    <div class="thanks-title">
                        <span v-if="thanksPeoples(article)">고마운 선생님 : </span>
                        <p>{{ thanksPeoples(article) }}</p>
                    </div>
                    <p v-html="article.content"></p>
                    <p class="date">{{$commonUtils.timestampToDate(article.createdDt)}}</p>
                </div>
            </router-link>
        </li>
    </ul>
    <kr_Pagination :totCnt="totCnt" :pageRow="pageRow" :currentNum="currentNum" :totalPage="totalPage" :pageCount="pageCount" @setNum="setNum"/>
</template>

<script>
import Pagination from '@/components/kr/common/Pagination.vue'
export default {
    components: {
        Pagination
    },
    props: {
        boardInfo: ''
    },
    data() {
        return {
            board: {},
            list: [],
            totalPage: '',
            // pageCount: window.innerWidth > 720 ? 10 : 5,
            pageCount: 5,
            totCnt: 0,

            // 게시글 parameter
            currentNum: this.$route.query.currentNum || 1,
            pageRow: 9,
        }
    },
    //20251217 추가 개발(혈액암)
    computed: {
        showStepBox() {
            return this.$store.getters.getHost === 'H0009'
        }
    },
    watch: {
        $route(to, from) {
            // 동일 게시판 안에서 이동
            if (to.query != from.query && to.path == from.path) {
                if(Object.keys(to.query).length === 0) this.init()
                for(let i in this.$route.query){
                    this[i] = this.$route.query[i]
                }

                this.getList()
            }
        },
        // 다른 게시판으로 이동
        boardInfo(oldVal, newVal) {
            this.init()
            this.getList()
        }
    },
    methods: {
        getList() {
            const boardNo = this.boardInfo.boardNo
            const params = {
                hospId: this.$store.getters.getHost,
                boardNo: boardNo,
                startIndex: this.currentNum,
                pageRow: this.pageRow,
                title: '',
                content: '',
                searchKeyword: '',
                item18: 'O'
            }
            this.axios.get(this.api.article.list + boardNo, {
                params: params
            })
                .then(res => {
                    if(res.data.list) this.list = res.data.list
                    this.board = res.data.board
                    this.totCnt = res.data.totCnt
                })
        },
        // pagination emit
        setNum(n) {
            this.currentNum = n
            this.goPage()
        },
        goPage() {
            const obj = { currentNum: this.currentNum, title: this.title, content: this.content, searchKeyword: this.searchKeyword };
            for (const key in obj) {
                if (obj[key] === null || obj[key] === '') {
                    delete obj[key];
                }
            }

            this.$router.push({ path: this.$route.path, query: obj });
        },
        // 데이터 초기화
        init() {
            this.currentNum = 1
        },
        thanksPeoples(article){
            const baseText = article.item1 || ''
            let doctorNames = []
            if (article.refDoctorList) {
                for (let i of article.refDoctorList) {
                    if (!i.drName) continue
                    if(i.deptNm){
                        doctorNames.push(`${i.deptNm} ${i.drName}`)
                    }else{
                        doctorNames.push(`${i.drName}`)
                    }
                }
            }
            if (baseText && doctorNames.length > 0) {
                return `${baseText}, ${doctorNames.join(', ')}`
            }
            if (baseText) {
                return baseText
            }
            if (doctorNames.length > 0) {
                return doctorNames.join(', ')
            }
            return ''
        }
    },
    mounted() {
        this.getList()
    },
}
</script>

<style scoped></style>
